import { useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * An image from an endpoint that requires the login token.
 *
 * A plain `<img src>` sends no Authorization header, so the server - correctly
 * - refuses it, and the page shows a broken-image icon with no explanation.
 * This fetches the bytes with the token attached and shows them from an object
 * URL instead.
 *
 * The object URL is revoked on unmount. Without that, a tutor scrolling
 * through a term's worth of marking leaks every photo they have looked at
 * until the tab is closed.
 */
export default function AuthImage({ path, alt, className, onClick }) {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let dead = false;
    let made = null;
    setSrc(null);
    setFailed(false);
    api.get(path, { responseType: "blob" })
      .then((r) => {
        if (dead) return;
        made = URL.createObjectURL(r.data);
        setSrc(made);
      })
      .catch(() => { if (!dead) setFailed(true); });
    return () => {
      dead = true;
      if (made) URL.revokeObjectURL(made);
    };
  }, [path]);

  if (failed) {
    return (
      <div className={`${className || ""} flex items-center justify-center bg-slate-100 text-[10px] text-slate-400 text-center p-1`}>
        could not load
      </div>
    );
  }
  if (!src) {
    return <div className={`${className || ""} bg-slate-100 animate-pulse`} />;
  }
  return <img src={src} alt={alt} className={className} onClick={onClick} />;
}
